/**
 * An unavailable read is not a card decline or proof that money did not move.
 * Shared by web and native; never use this classification to retry a mutation.
 */
export const CHECKOUT_STATUS_UNAVAILABLE_MESSAGE =
  "We couldn't confirm your payment or booking status. Your existing attempt has been kept. Check your bookings before trying again; don't start another booking for the same dates.";

export function isCheckoutStatusUnavailable(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const value = error as { status?: unknown; code?: unknown; name?: unknown };
  return value.status === 0 || value.status === 408 ||
    (typeof value.status === "number" && value.status >= 500 && value.status <= 599) ||
    value.code === "BOOKING_API_TIMEOUT" ||
    value.name === "TimeoutError" ||
    value.name === "AbortError" ||
    error instanceof TypeError;
}
